import { inject, Injector } from '@angular/core';

import { MsalService } from '@azure/msal-angular';
import { ConfigurationService } from '@webgate/angular-azure-core';
import { firstValueFrom } from 'rxjs';

/** MSAL v4 needs initialize(); core config may load in parallel — resolve config before constructing MsalService. */
export function msalBootstrapInitializer(): Promise<void> {
  const injector = inject(Injector);
  const configurationService = inject(ConfigurationService);
  const loaded = configurationService.getConfiguration();
  const configReady = !loaded?.clientId
    ? configurationService.load('/assets/config/config.json')
    : Promise.resolve(true);
  return configReady.then(() => {
    const msalService = injector.get(MsalService);
    return firstValueFrom(msalService.initialize());
  });
}
